import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';

import { MeetingReviewComponent } from '@core/components/meeting-review/meeting-review.component';
import { ZonedDatePipe } from '@core/pipes/zoned-time-to-utc.pipe';

import { IconComponent } from '@shared/icon/icon.component';
import { DateFnsModule, FormatPipeModule } from 'lingo2-ngx-date-fns';
import { OnUiCoverModule } from 'onclass-ui';

@NgModule({
  declarations: [MeetingReviewComponent],
  imports: [
    LocaleSharedModule,
    CommonModule,
    RouterModule,
    DateFnsModule,
    OnUiCoverModule,
    FormatPipeModule,
    ZonedDatePipe,
    IconComponent,
  ],
  exports: [MeetingReviewComponent],
})
export class MeetingReviewModule {}
